"use client";

import { ArrowUpRight, Check, Menu, Monitor, Smartphone, Tablet } from "lucide-react";
import { useState } from "react";
import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";
import type { WebdesignPageCopy } from "./webdesign-page-copy";
import styles from "./webdesign-studio.module.scss";

type Device = "desktop" | "tablet" | "mobile";
const DEVICES = [{ id: "desktop", Icon: Monitor }, { id: "tablet", Icon: Tablet }, { id: "mobile", Icon: Smartphone }] as const;

export function CcWebdesignResponsive({ copy }: { copy: WebdesignPageCopy["responsive"] }) {
  const [device, setDevice] = useState<Device>("desktop");
  return (
    <section className={styles.responsiveSection} data-cc-nav="light" aria-labelledby="webdesign-responsive-title">
      <div className={styles.shell}>
        <div className={styles.responsiveHeading}><div><CcSanjayaEyebrow>{copy.eyebrow}</CcSanjayaEyebrow><h2 id="webdesign-responsive-title">{copy.title}</h2></div><div><p>{copy.lead}</p><ul>{copy.points.map(point => <li key={point}><Check size={17} />{point}</li>)}</ul></div></div>
        <div className={styles.responsiveStage}>
          <div className={styles.deviceToolbar}><span>{copy.instruction}</span><div role="group" aria-label={copy.controlLabel}>{DEVICES.map(({ id, Icon }) => <button type="button" key={id} aria-pressed={device === id} aria-controls="webdesign-responsive-preview" onClick={() => setDevice(id)}><Icon size={18} /><span>{copy[id]}</span></button>)}</div></div>
          <div className={styles.prototypeWrap}>
            <div className={styles.prototype} data-device={device} id="webdesign-responsive-preview">
              <div className={styles.prototypeNav}><span className={styles.prototypeLogo}>still<span>®</span></span><div>{copy.prototype.nav.map(item => <span key={item}>{item}</span>)}</div><Menu size={20} aria-hidden="true" /></div>
              <div className={styles.prototypeBody}><div className={styles.prototypeCopy}><span>{copy.prototype.label}</span><h3>{copy.prototype.title}</h3><p>{copy.prototype.text}</p><span className={styles.prototypeLink}>{copy.prototype.link}<ArrowUpRight size={17} /></span></div><div className={styles.roomArt} aria-hidden="true"><div className={styles.arch} /><div className={styles.sunlight} /><div className={styles.sphere} /><div className={styles.pedestal} /><div className={styles.vase} /><span>STILL — 01</span></div></div>
              <div className={styles.prototypeFooter}><span>{copy.prototype.footer}</span><span>© STILL STUDIO</span></div>
            </div>
          </div>
          <p className={styles.prototypeNote}>{copy.note}</p>
        </div>
      </div>
    </section>
  );
}
